/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function SortDown({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2.4 3a.6.6 0 0 1 .6-.6h11.5a.6.6 0 1 1 0 1.2H3a.6.6 0 0 1-.6-.6ZM10.4 13a.6.6 0 0 1 .6-.6h3.5a.6.6 0 1 1 0 1.2H11a.6.6 0 0 1-.6-.6ZM8.4 8a.6.6 0 0 1 .6-.6h5.5a.6.6 0 1 1 0 1.2H9a.6.6 0 0 1-.6-.6ZM5.1 6a.6.6 0 1 0-1.2 0v6.552l-1.976-1.976a.6.6 0 0 0-.848.848l3 3a.6.6 0 0 0 .848 0l3-3a.6.6 0 0 0-.848-.848L5.1 12.552V6Z" /></svg>;
}
;